import { render, staticRenderFns } from "./KnAppSidebar.vue?vue&type=template&id=918af922"
import script from "./KnAppSidebar.vue?vue&type=script&lang=js"
export * from "./KnAppSidebar.vue?vue&type=script&lang=js"
import style0 from "./KnAppSidebar.vue?vue&type=style&index=0&id=918af922&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports